import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AzaraWrapperComponent } from "./components/azara-wrapper/azara-wrapper.component";
import { NoInitialTransitionDirective } from "./directives/no-initial-transition/no-initial-transition.directive";
import { FacilityAndDepartmentSelectorComponent } from "./components/facility-and-department-selector/facility-and-department-selector.component";
import { DropdownModule } from "primeng/dropdown";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { UpdatedAtPipe } from "@shared/pipes/updatedAt/updated-at.pipe";
import { EmptyValuePipe } from "@shared/pipes/empty-value/empty-value.pipe";
import { DividerModule } from "primeng/divider";

@NgModule({
    declarations: [
        AzaraWrapperComponent,
        NoInitialTransitionDirective,
        FacilityAndDepartmentSelectorComponent,
        UpdatedAtPipe,
        EmptyValuePipe
    ],
    imports: [CommonModule, FormsModule, DropdownModule, DividerModule, FontAwesomeModule],
    exports: [
        FacilityAndDepartmentSelectorComponent,
        AzaraWrapperComponent,
        NoInitialTransitionDirective,
        UpdatedAtPipe,
        EmptyValuePipe
    ],
})
export class SharedModule {}
